var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPhoneBlue = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12305_17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.58333 3.66675H8.25L10.0833 8.25008L7.79167 9.62508C8.77338 11.6157 10.3844 13.2267 12.375 14.2084L13.75 11.9167L18.3333 13.7501V17.4167C18.3333 17.903 18.1402 18.3693 17.7964 18.7131C17.4525 19.0569 16.9862 19.2501 16.5 19.2501C12.9243 19.0328 9.55181 17.5144 7.01876 14.9813C4.48571 12.4483 2.9673 9.07576 2.75 5.50008C2.75 5.01385 2.94315 4.54754 3.28697 4.20372C3.63079 3.8599 4.0971 3.66675 4.58333 3.66675Z",
    stroke: "#1F5FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 6.41675C14.2362 6.41675 14.7025 6.6099 15.0464 6.95372C15.3902 7.29754 15.5833 7.76385 15.5833 8.25008",
    stroke: "#1F5FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 2.75C15.2087 2.75 16.6076 3.32946 17.6391 4.36091C18.6705 5.39236 19.25 6.79131 19.25 8.25",
    stroke: "#1F5FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12305_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPhoneBlue);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/phone-blue.6307a9f2e3fe4959de9dec1d3e6b933c.svg";